import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MotionMasterConnectionConfig } from 'motion-master-client';

import { ConnectionService } from '@app/services/connection.service';
import { GlobalService } from '@app/services/global.service';
import { SettingService } from '@app/services/setting.service';
import { getCurrentValue } from '@app/util';

@Component({
  selector: 'app-disconnect-button',
  templateUrl: './disconnect-button.component.html',
  imports: [NgbTooltip, AsyncPipe],
})
export class DisconnectButtonComponent {
  private cn = inject(ConnectionService);
  private globalService = inject(GlobalService);
  private settingService = inject(SettingService);

  isConnectedWithExpertMode$ = this.globalService.isConnectedWithExpertMode$;

  get tooltipText() {
    const isConnectedWithExpertMode = getCurrentValue(this.globalService.isConnectedWithExpertMode$);
    return isConnectedWithExpertMode
      ? 'Disconnect from the server and return to the START page.'
      : 'Stop the server and return to the START page.';
  }

  onDisconnect() {
    const isConnectedWithExpertMode = getCurrentValue(this.globalService.isConnectedWithExpertMode$);
    this.cn.disconnect();

    if (!isConnectedWithExpertMode) {
      this.globalService.stopMotionMaster();
      this.settingService.updateSettingState({ connectionConfig: undefined });
    } else {
      const connectionConfig = getCurrentValue(this.settingService.connectionConfig$);
      this.settingService.updateSettingState({
        connectionConfig: {
          ...(connectionConfig ?? {}),
          remember: false,
        } as MotionMasterConnectionConfig,
      });
    }
  }
}
